export default __webpack_public_path__ + "static/1.1_IT-0b29e9c882eed84014f1a863314ccc34.png";